import ListResult from './ListResult'
import type { NfdRecord } from 'api/api-client'

interface ManageResultsListProps {
  results: NfdRecord[]
  walletAddress: string
}

export default function ManageResultsList({ results, walletAddress }: ManageResultsListProps) {
  return (
    <div className="bg-white shadow overflow-hidden sm:rounded-md">
      <ul role="list" className="divide-y divide-gray-200">
        {results.map((nfd) => (
          <ListResult key={nfd.name} nfd={nfd} walletAddress={walletAddress} />
        ))}
      </ul>
    </div>
  )
}
